import script from "./ExpenseCategoryChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpenseCategoryChart.vue?vue&type=script&setup=true&lang=ts"

import "./ExpenseCategoryChart.vue?vue&type=style&index=0&id=22f21714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f21714"]])

export default __exports__